import React, { useEffect, useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { Box, Button, Grid, Paper, Typography } from '@material-ui/core';
import VoiceChatOutlinedIcon from '@material-ui/icons/VoiceChatOutlined';
import { StateContext, DispatchContext } from '../../../context/Provider';

const ClassBanner = (props) => {

    const parts = window.location.hostname.split('.');
    let last_index = -2;

    const currentSubdomain = parts.slice(0, last_index).join('.');

    const [bgColor, setBgColor] = useState('#2091EA');
    const [meetingLink, setMeetingLink] = useState(
        currentSubdomain == 'console' 
            ? 'https://meet.academeportal.com/' 
            : 'https://meet.google.com/'
    );

    const appState = useContext(StateContext);
    const { authState } = appState;

    const styles = {
        paperContainer: {
            backgroundColor: bgColor
        },
        textWhite: {
            color: '#fff'
        }
    };

    useEffect(() => {

        if (props.themeColor) {
            setBgColor(props.themeColor);
        }

        console.log(meetingLink);

    }, [props.themeColor]);

    return (
        <Grid item xs={12} sm={12} md={10} lg={8} xl={8}>
            <Paper elevation={1} style={styles.paperContainer}>
                <Box p={2} height="120px" style={styles.textWhite}>
                    <Grid container justify="space-between">
                        <Grid item xl={10} lg={8} md={8} sm={8} xs={8}>
                            <Typography variant="h6">{props.classroomName}</Typography>
                            <Typography variant="subtitle2">{props.sectionName}</Typography>
                            <Box pt={1}>
                                <Typography variant="button">Code: {props.classcode}</Typography>
                            </Box>
                        </Grid>
                        { authState.user.role_id === 4 && (
                            <Grid item xl={2} lg={4} md={4} sm={4} xs={4}>
                                <Button 
                                    startIcon={<VoiceChatOutlinedIcon />}
                                    component={Link}
                                    to={{ pathname: meetingLink }} 
                                    target="_blank"
                                    variant="contained" 
                                    color="default" 
                                    size="small" 
                                    disableElevation
                                    style={{float: 'right', whiteSpace: 'nowrap'}}
                                >
                                    Generate meeting link
                                </Button>
                            </Grid> 
                        )}                                               
                    </Grid>
                </Box>

                <Box pb={2}></Box>

            </Paper>
        </Grid>
    );
}

export default ClassBanner;